import ApiClient from './ApiClient';

export default class MenuApi {
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getMenus() {
    return this.apiClient.get({ path: '/api/menus' });
  }

  changeMenuItem(body) {
    return this.apiClient.post({ path: '/api/menus', body });
  }

  updateMenuItem(id, body) {
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling updateMenuItem");
    }

    return this.apiClient.put({ path: `/api/menus/${id}`, body });
  }

  deleteMenuItem(id) {
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling deleteMenuItem");
    }
    return this.apiClient.del({ path: `/api/menus/${id}` });
  }
}
